import React from 'react';

const Activity = () => {
  const services = [
    {
      title: "ELEVATOR AND ESCALATOR SYSTEMS",
      description: "Installation, modernization, and maintenance of lift systems with advanced control systems.",
      features: []
    },
    {
      title: "INDUSTRIAL AUTOMATION",
      description: "Custom automation systems with PLC programming and SCADA development.",
      features: []
    },
    {
      title: "SOLAR POWER SYSTEMS",
      description: "Custom solar power systems for residential and commercial properties.",
      features: []
    },
    {
      title: "SMART PARKING TOWER",
      description: "Automated vertical parking systems that maximize space utilization.",
      features: []
    },
    {
      title: "IoT SOLUTIONS",
      description: "Advanced IoT solutions that enable remote control, enhanced monitoring, and intelligent automation of electromechanical systems.",
      features: [
        "Remote Device Control",
        "Real-time Monitoring & Analytics",
        "Enhanced Automation with IoT sensors"
      ]
    },
    {
      title: "SMART HOME SOLUTIONS",
      description: "Transform your home with intelligent automation for enhanced comfort and security.",
      features: [
        "Centralized Mobile Control",
        "Smart Lighting Systems",
        "Advanced Security Integration",
        "Automated Scenarios"
      ]
    },
    {
      title: "STEEL STRUCTURES SOLUTIONS",
      description: "Comprehensive steel structure solutions for industrial, commercial, and specialized construction needs.",
      features: [
        "Design & Engineering with 3D modeling",
        "Precision Fabrication",
        "Professional Installation",
        "Customized Solutions",
        "Quality Assurance with international standards"
      ]
    }
  ];

  return (
    <div className="activity-page">
      <section className="page-header">
        <div className="container">
          <h1>Our Activities & Services</h1>
          <p>Comprehensive electromechanical solutions for all your needs</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Our Core Services</h2>
          <div className="services-list">
            {services.map((service, index) => (
              <div className="service-item" key={index}>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                
                {service.features.length > 0 && (
                  <>
                    <h4 style={{ marginTop: '20px', color: '#1a365d' }}>Key Features:</h4>
                    <ul>
                      {service.features.map((feature, idx) => (
                        <li key={idx}>{feature}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Activity;